import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiArrowRight, FiClock, FiDollarSign } = FiIcons;

const Hero = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(59,130,246,0.1),transparent_70%)]"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-32">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center justify-between mb-20"
        >
          <div className="flex items-center space-x-4">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752036442288-burbank-insurance-round-logo.png"
              alt="Burbank Insurance"
              className="w-12 h-12 rounded-full"
            />
            <div>
              <h3 className="font-bold text-lg">Burbank Insurance</h3>
              <p className="text-blue-300 text-sm">CA License #6013543</p>
            </div>
          </div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Main Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-8"
          >
            <div className="space-y-6">
              <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
                Business
                <span className="block text-blue-400">Insurance</span>
                <span className="block text-3xl lg:text-4xl font-normal text-gray-300">
                  In Minutes
                </span>
              </h1>
              <p className="text-xl text-gray-300 max-w-lg">
                Instant quotes. Same-day coverage. Built for California entrepreneurs.
              </p>
            </div>

            <div className="flex flex-wrap gap-6 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiClock} className="text-blue-400" />
                <span>10-minute application</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiDollarSign} className="text-blue-400" />
                <span>Transparent pricing</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiShield} className="text-blue-400" />
                <span>Licensed professionals</span>
              </div>
            </div>

            <motion.a
              href="https://quote.burbankinsuranceservices.com/Jn9lan"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg flex items-center justify-center space-x-3 shadow-2xl transition-all duration-300 w-fit"
            >
              <span>Get Quote Now</span>
              <SafeIcon icon={FiArrowRight} />
            </motion.a>
          </motion.div>

          {/* Right Column - Coterie Partnership */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="relative"
          >
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
              <div className="text-center space-y-6">
                <div className="bg-white rounded-2xl p-6 shadow-xl">
                  <img
                    src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752036427196-Coterie_Logo_Trans_FullColor-1024x185.png"
                    alt="Coterie Insurance"
                    className="h-16 w-auto mx-auto"
                  />
                </div>
                <div className="space-y-4">
                  <h3 className="text-2xl font-bold">Powered by Coterie</h3>
                  <p className="text-gray-300">
                    Digital-first insurance technology trusted by 50,000+ businesses
                  </p>
                  <div className="grid grid-cols-2 gap-4 pt-4">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-blue-400">A-</div>
                      <div className="text-sm text-gray-400">AM Best Rating</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-blue-400">$2B+</div>
                      <div className="text-sm text-gray-400">Coverage Written</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;